import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import classNames from 'classnames';
import React from 'react';
import { useTabsContext } from './tabs-context.esm.js';
import { TAB_THEME_KEY } from './types.esm.js';
import { omit, pick, EMPTY_OBJECT } from '../../utils/object.esm.js';
import { getLayout, getPosition, omitPosition, omitLayout } from '../../utils/props-utils.esm.js';
import { FlexPrivate } from '../_primitives/flex/flex.esm.js';
import { ButtonPrivate } from '../button/button.esm.js';
import { transitions } from '../../themes/theme-keys/transitions.esm.js';

var _excluded = ["variant", "className", "direction", "orientation", "disabled", "enableTransition", "sx"];
var TabScrollButton = /*#__PURE__*/React.forwardRef(function TabScrollButton(props, ref) {
  var _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'scrollButton' : _props$variant,
    className = props.className,
    direction = props.direction,
    orientation = props.orientation,
    disabled = props.disabled,
    enableTransition = props.enableTransition,
    _props$sx = props.sx,
    sx = _props$sx === void 0 ? EMPTY_OBJECT : _props$sx,
    rest = _objectWithoutProperties(props, _excluded);
  var _useTabsContext = useTabsContext(),
    tabVariant = _useTabsContext.variant;

  // remove size from layout fields
  var combineLayout = omit(_objectSpread2(_objectSpread2(_objectSpread2({}, orientation === 'vertical' ? {} : {
    height: '100%'
  }), getLayout(rest)), getLayout(sx)), ['size']);
  var combinedPosition = _objectSpread2(_objectSpread2({}, getPosition(rest)), getPosition(sx));
  return orientation === 'vertical' ? /*#__PURE__*/React.createElement(FlexPrivate, {
    className: classNames('csg-tui-tab-scroll-button-wrapper', {
      'is-left': direction === 'left',
      'is-right': direction !== 'left'
    }),
    width: "100%",
    absolute: true,
    justifyContent: "center",
    __css: {
      left: combinedPosition.left ? combinedPosition.left : 0,
      right: combinedPosition.right ? combinedPosition.right : 0,
      '&.is-left': {
        top: combinedPosition.top ? combinedPosition.top : 0
      },
      '&.is-right': {
        bottom: combinedPosition.bottom ? combinedPosition.bottom : 0
      }
    }
  }, /*#__PURE__*/React.createElement(ButtonPrivate, _extends({
    ref: ref,
    variant: tabVariant ? "".concat(tabVariant, ".").concat(variant) : variant,
    __themeKey: TAB_THEME_KEY,
    className: classNames({
      'is-disabled': disabled,
      'is-left': direction === 'left',
      'is-right': direction !== 'left'
    }, className),
    __css: _objectSpread2({
      flexShrink: 0,
      cursor: disabled ? 'default' : 'pointer',
      transition: transitions.create('transform'),
      '&.is-right': {
        transform: 'translateY(70%)',
        borderTopLeftRadius: 'pill',
        borderTopRightRadius: 'pill'
      },
      '&.is-left': {
        transform: 'translateY(-70%)',
        borderBottomLeftRadius: 'pill',
        borderBottomRightRadius: 'pill'
      },
      '&:hover': {
        transform: 'translateY(0)'
      },
      '&.is-disabled': {
        opacity: 0
      },
      '& svg': {
        transform: 'rotate(90deg)'
      }
    }, combineLayout),
    disabled: disabled,
    size: "1em",
    icon: direction === 'left' ? 'chevronLeft' : 'chevronRight',
    sx: omitPosition(omitLayout(sx))
  }, _objectSpread2(_objectSpread2({}, omitPosition(omitLayout(rest))), pick(rest, ['size']))))) : /*#__PURE__*/React.createElement(ButtonPrivate, _extends({
    ref: ref,
    variant: tabVariant ? "".concat(tabVariant, ".scrollButton") : variant,
    __themeKey: TAB_THEME_KEY,
    className: classNames({
      'is-disabled': disabled,
      'is-left': direction === 'left',
      'is-right': direction !== 'left'
    }, className),
    __css: _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
      flexShrink: 0,
      position: 'absolute',
      cursor: disabled ? 'default' : 'pointer',
      zIndex: 2
    }, direction === 'left' ? {
      justifyContent: 'flex-end'
    } : {}), orientation === 'horizontal' ? {
      top: combinedPosition.top ? combinedPosition.top : '-1px',
      bottom: combinedPosition.bottom ? combinedPosition.bottom : 0
    } : {
      left: combinedPosition.left ? combinedPosition.left : 0,
      right: combinedPosition.right ? combinedPosition.right : 0
    }), direction === 'left' ? {
      left: combinedPosition.left ? combinedPosition.left : 0
    } : {
      right: combinedPosition.right ? combinedPosition.right : 0
    }), enableTransition ? _objectSpread2({
      borderRadius: 'pill',
      transition: transitions.create('transform')
    }, direction === 'left' ? {
      transform: 'translateX(-80%)',
      '&:hover': {
        transform: 'translateX(-40%)'
      }
    } : {
      transform: 'translateX(80%)',
      '&:hover': {
        transform: 'translateX(40%)'
      }
    }) : {
      background: direction === 'left' ? 'linear-gradient(270deg, rgba(255,255,255,0) 0%, #FFFFFF 100%)' : 'linear-gradient(90deg, rgba(255,255,255,0) 0%, #FFFFFF 100%)'
    }), {}, {
      '&.is-disabled': {
        opacity: 0
      }
    }, combineLayout),
    disabled: disabled,
    size: "1em",
    icon: direction === 'left' ? 'mui-keyboardArrowLeft' : 'mui-keyboardArrowRight',
    sx: omitPosition(omitLayout(sx))
  }, _objectSpread2(_objectSpread2({}, omitPosition(omitLayout(rest))), pick(rest, ['size']))));
});

export default TabScrollButton;
//# sourceMappingURL=tab-scroll-button.esm.js.map
